// WHAT ONE MORE WORKER WOULD BUY (playtest 14). Early in the year nobody
// knew what to ask for at dawn - "I have no idea what that means in round
// one" - and the table only started trading workers once everyone had
// learned the others' boards. So the dawn reads each board and says, per
// role, what the next worker is for, in a few words: the ask a player would
// make if they knew. A role that has declared a NEED (state.needs) says
// that instead. Pure; read by the dawn band and the table.
import { ROLES } from './constants';
import { cityOf, BUILDINGS } from './city';
import { hallOf, CARDS_PER_WORKER } from './hall';
import { unitsOf } from './units';
import { TECHS, techReachable } from './cards';

const empty = (civ) => cityOf(civ).buildings.filter((b) => !b.burned && b.type !== 'house' && (b.staffed || 0) < (BUILDINGS[b.type]?.slots || 1));

const ASK = {
  culture: (civ) => `${CARDS_PER_WORKER} more cards${(hallOf(civ)?.deck?.length || 0) + (hallOf(civ)?.discard?.length || 0) <= 4 ? '' : ' to choose from'}`,
  trade: (civ) => {
    const open = empty(civ);
    if (!open.length) return 'two shifts: build or take in land';
    const first = BUILDINGS[open[0].type]?.name || open[0].type;
    return open.length === 1 ? `a shift in the ${first}` : `shifts in the ${first}${open.length > 2 ? ` and ${open.length - 1} more` : ' and one more'}`;
  },
  science: (civ) => {
    if ((civ.goods || 0) < 1) return 'a study - a mix needs a good too';
    const aim = Object.keys(TECHS).some((id) => techReachable(civ, id)) ? ' aimed at a technology' : '';
    return `another mix${aim}`;
  },
  military: (civ) => {
    const units = unitsOf(civ);
    if (!units.length) return 'nothing yet - the Stewards train units';
    const camp = (civ.menaces || []).length;
    return camp ? 'two more steps, toward the camp' : 'two more steps across the map';
  },
};

/** Per role: what the next worker is for, or the need the role declared. */
export const asksOf = (state) => Object.fromEntries(ROLES.map((r) => {
  const declared = state?.needs?.[r];
  if (declared) return [r, `needs ${declared}`];
  try { return [r, ASK[r](state.civ)]; } catch { return [r, '']; }
}));
